module.exports = __webpack_public_path__ + "img/Conventional.5b956b47.jpg";